import Button from '@/shared/Button';
import React, { memo } from 'react';

type ViewMoreResultsProps = {
  onClick: () => void;
  isLoading: boolean;
  show: boolean;
  label: string;
};

const ViewMoreResults = ({ onClick, isLoading, show, label }: ViewMoreResultsProps) => {
  if (!show) return null;

  return (
    <Button
      dataTestId="view-more-btn"
      className="w-72 mx-auto mt-s6 mb-s9"
      theme="secondary"
      onClick={onClick}
      isLoading={isLoading}
    >
      {label || 'View more results'}
    </Button>
  );
};

export default memo(ViewMoreResults);
